interface IBottonTopProducts {
  name: string
  id: number
  icon?: string
  isActive: boolean
  onClick: (id: number) => void
}

const BottonTopProducts = ({name, id, icon, isActive, onClick}: IBottonTopProducts) => {
  return (
    <div className='nav nav-pills nav-pills-custom mb-3' role='tablist'>
      <div className='nav-item mb-3 me-3 me-lg-6' role='presentation'>
        <button
          type='button'
          onClick={() => onClick(id)}
          className={`nav-link btn btn-outline btn-flex btn-color-muted ${
            isActive ? 'btn-active-color-danger active' : ''
          } flex-column w-80px h-85px pt-5 pb-2 position-relative`}
          role='tab'
        >
          <div className='nav-icon mb-3'>
            <i className={icon ?? 'ki-outline ki-car fs-1'}></i>
          </div>

          <span className='nav-text text-gray-800 fw-bold fs-6 lh-1'>{name}</span>

          {isActive && (
            <span
              className='position-absolute bottom-0 h-4px'
              style={{
                width: '80%',
                left: '50%',
                transform: 'translateX(-50%)',
                backgroundColor: '#f1416c',
              }}
            ></span>
          )}
        </button>
      </div>
    </div>
  )
}

export {BottonTopProducts}
